module.exports = __webpack_public_path__ + "img/MES1_Indice6.f9575599.png";